import { render } from "./monitoring.vue?vue&type=template&id=8c06b968"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__